<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 msg-return-gender-feminine
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Pedido Compra, Fornecedor, ..."
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>

          <t-input-person supplier
                          v-model="form.supplierId"/>

          <t-input-search v-model="form.statusPurchaseInvoice" select
                          label="Status Pedido Compra"/>

        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               link-primary-column="purchaseInvoiceNumber"
               primary-key-column="purchaseInvoiceNumber">

        <template #first-column="{item}">

          <t-list-link-primary formatter="lpad:4"
                               :label="item.purchaseInvoiceNumber" :userAuth="userAuth" :id="item.purchaseInvoiceNumber"
                               :path="currentPage.path"/>


        </template>


      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'PurchaseInvoice',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      form: {
        companyId: 0,
        supplierId: 0,
        typePaymentId: 0,
        paymentPlanId: 0,
        contactId: 0,
        issueDate: "",
        statusPurchaseInvoice: 0, //Pendente
      },
      fields: [
        {key: "purchaseInvoiceNumber", label: "Cód. Compra"},
        {key: "supplierNameAutomatically", label: "Fornecedor"},
        {key: "supplierFederalTaxpayer", label: "CNPJ/CPF"},
        {key: "qtyItems", label: "Qtd. Itens"},
        {key: "amount", label: "Valor Total", formatter: "number"},
        {key: "statusPurchaseInvoice", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      companyOptions: [],
      typePaymentOptions: [],
      paymentPlanOptions: [],
      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {
      delete this.form.status
    },
    async mountedContinued() {

      await http.list(this.userAuth.currentPage.path + "/selectRelationList").then((response) => {
        this.companyOptions = response.companyOptions
        this.typePaymentOptions = response.typePaymentOptions
        this.paymentPlanOptions = response.paymentPlanOptions
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()


  },
}
</script>
